import { SignatureData } from '../types'

export const demoSignatures: SignatureData[] = [
  {
    name: 'John Doe',
    title: 'Senior Software Engineer',
    company: 'TechCorp Inc.',
    email: 'john.doe@techcorp.com',
    phone: '+1 (555) 123-4567',
    website: 'https://techcorp.com',
    address: 'San Francisco, CA',
    industry: 'Technology',
    logo: null,
    showLogo: true,
    backgroundColor: '#ffffff',
    textColor: '#2d3748',
    accentColor: '#3182ce',
    font: 'Inter',
    layout: 'horizontal',
    spacing: 18,
    iconSize: 18,
    iconPadding: 6,
    showQr: false,
    subtext: 'Building the future, one line of code at a time.',
    hideEmail: false,
    hidePhone: false,
    hideUrl: false,
    logoWidth: 56,
    logoHeight: 56,
    rotateLogo: false,
  },
  {
    name: 'Sarah Johnson',
    title: 'Marketing Director',
    company: 'Creative Solutions',
    email: 'sarah@creativesolutions.com',
    phone: '+1 (555) 987-6543',
    website: 'https://creativesolutions.com',
    address: 'New York, NY',
    industry: 'Marketing & Advertising',
    logo: null,
    showLogo: true,
    backgroundColor: '#f7fafc',
    textColor: '#1a202c',
    accentColor: '#e53e3e',
    font: 'Poppins',
    layout: 'vertical',
    spacing: 16,
    iconSize: 20,
    iconPadding: 8,
    showQr: true,
    subtext: 'Let\'s create something amazing together!',
    hideEmail: false,
    hidePhone: false,
    hideUrl: false,
    logoWidth: 64,
    logoHeight: 64,
    rotateLogo: false,
  },
  {
    name: 'Alex Chen',
    title: 'Product Manager',
    company: 'InnovateLab',
    email: 'alex.chen@innovatelab.io',
    phone: '+1 (555) 456-7890',
    website: 'https://innovatelab.io',
    address: 'Austin, TX',
    industry: 'Product Development',
    logo: null,
    showLogo: false,
    backgroundColor: '#2d3748',
    textColor: '#f7fafc',
    accentColor: '#48bb78',
    font: 'JetBrains Mono',
    layout: 'horizontal',
    spacing: 20,
    iconSize: 16,
    iconPadding: 4,
    showQr: false,
    subtext: 'Turning ideas into impactful products.',
    hideEmail: false,
    hidePhone: false,
    hideUrl: false,
    logoWidth: 48,
    logoHeight: 48,
    rotateLogo: false,
  }
]

export const getRandomDemoSignature = (): SignatureData => {
  const randomIndex = Math.floor(Math.random() * demoSignatures.length)
  return { ...demoSignatures[randomIndex] }
}
